export default function extractMerchantReference(pathname: string) {
  const urlParts = pathname.split('/');
  if (urlParts[1] && urlParts[1].length > 0) {
    return urlParts[1];
  }
  return null;
}
